var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-woman';
                    var viewUrl = 'sprite.svg#view-icon-woman';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 63 66',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };